<template>
    <div class="desctop-nav-main">
        <div v-for="(item, index) in setup.burger_menu_nav" class="parent-category" :key="index">
            <span class="category-name">{{item.category}}</span>
            <div class="menu-list" v-if="item.nav != false">
                <ul>
                    <li v-for="link in item.nav" :key="link.name">
                        <router-link :to="link.link" @click.native="startLoader(link.link)">{{link.name}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'nav-main',
        data () {
            return {
                routerName: this.$router.history.current.name,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        methods: {
            startLoader(name) {
                const nameOfLink = name.replace(/\#.*/,'').replace('/', '');
                if (name != '/fine-finish') {
                    if (nameOfLink != this.routerName) {
                        this.$parent.$parent.$refs.topProgress.start();
                    }
                    // setTimeout(() => {
                    //     this.$parent.$parent.$refs.topProgress.done();
                    // }, 1000);
                }
            },
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/burger-nav-main.scss';
</style>